import { Construction } from 'lucide-react';

export default function ComingSoon({ title, sprint }) {
  return (
    <div className="p-8 max-w-xl mx-auto">
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-center">
        <Construction className="w-10 h-10 text-amber-500 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-gray-900 mb-1">{title || 'Coming soon'}</h2>
        <p className="text-sm text-gray-600">
          {sprint ? `This page lands in Phase ${sprint} of the frontend rebuild.` :
                    'The backend endpoints are ready; this page is not yet wired up.'}
        </p>
      </div>
    </div>
  );
}
